import { Helmet } from 'react-helmet-async';
import { HtsListView } from 'src/sections/hts/view';

export default function HtsListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: HTS Codes</title>
      </Helmet>

      <HtsListView />
    </>
  );
}
